import React, { useEffect, useState } from 'react';
import { Link, useLocation  } from 'react-router-dom';
import { Toaster, toast } from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
import { GetAllQuestions, DeleteQuestion, GetAllLevels } from '../services/questionservice';
import { GetAllSubjects } from '../services/isubjectservice';
function Question() {
    const [questions, setQuestions] = useState([]);
    const [subjectpk, setSubjectPk] = useState(0);
    const [level, setLevel] = useState(0);
    const [subject, setSubject] = useState('');
    const [qlevels, setQLevels] = useState([]);
    const [iscode, setIsCode] = useState(-1);

    const location = useLocation();    
    const { successMessage } = location.state || {};
    let navigate = useNavigate();  

    useEffect(() => {
        fetchQuestions(subjectpk, level, iscode);
        fillSubject();
        fetchQLevels();
        toast(successMessage);
    }, []);

    const fetchQuestions = async (subject_pk, level_pk, iscode) => {
        const data = await GetAllQuestions(subject_pk, level_pk, iscode);
        const jsonQuestionsList = JSON.parse(data);
        setQuestions(jsonQuestionsList || []);
    };

    const fetchQLevels = async () => {
            const data = await GetAllLevels();
            const jsonLevelList = JSON.parse(data);
            setQLevels(jsonLevelList || []);
        };

    const fillSubject = async () => {
            try {
                const dataList = await GetAllSubjects();
                const jsonDataList = JSON.parse(dataList);
                setSubject(jsonDataList);
            } catch (error) {
                console.error('Error fetching the data:', error);
            }
    }

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this question?')) {
            await DeleteQuestion(id);
            fetchQuestions(subjectpk, level, iscode);
        }
    };

    const handleEdit = (id) => {  
        navigate('/question/add?pk='+id);
    };

    const handleSubjectChange = (id) => {  
        setSubjectPk(id);
        fetchQuestions(id, level, iscode);
    };
    const handleLevelChange = (id) => {  
        setLevel(id);
        fetchQuestions(subjectpk, id, iscode);
    };
    
    const handleIsCodeChange = (e) => {
        const clickedValue = (e.target.checked == false) ? 0 : 1;
        setIsCode(clickedValue);
        fetchQuestions(subjectpk, level, clickedValue);
    };
    return (
        <>
            <div class="row">
                <div class="col-md-12 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-2">
                                    <p class="card-title mb-0">Questions</p>
                                </div>
                                <div class="col-md-3">
                                    <select class="form-control dropdown"  onChange={(e) => handleSubjectChange(e.target.value)} value={subjectpk}>
                                                <option value="">Subject</option>
                                                {subject && subject.map((item) => (
                                                    <option value={item.pk}>{item.name}</option>
                                                ))}
                                            </select>
                                </div>
                                <div class="col-md-3">
                                    <select class="form-control dropdown" onChange={(e) => handleLevelChange(e.target.value)}  value={level}>
                                                <option value="">Level</option>
                                                {qlevels && qlevels.map((item) => (
                                                    <option value={item.key}>{item.value}</option>
                                                ))}
                                            </select>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                    <label for="txtQuestion" className='checkbox-label'>Is Code?</label>
                                    <input
                                        type="checkbox"
                                        name="txtcode"
                                        onChange={handleIsCodeChange}
                                    />
                                </div>
                                </div>
                                <div class="col-md-2 right-align">
                                <Link to="/question/add" className='nav-link'>
                                    <button type="submit" class="btn btn-primary me-2">New Question</button>
                                </Link>
                                </div>
                            </div>
                            
                            <div class="table-responsive">
                                <table class="table table-striped table-borderless">
                                    <thead>
                                        <tr>
                                            <th>Pk</th>
                                            <th>Question</th>
                                            <th>Answer</th>
                                            <th>Subject</th>
                                            <th>Level</th>
                                            <th>Is Code</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        questions?.map((item) => (
                                            <tr>
                                                <td>{item.pk}</td>
                                                <td><div class="s-wrap">{item.question}</div></td>
                                                <td><div class="m-wrap"><span dangerouslySetInnerHTML={{ __html: item.answer }} /></div></td>
                                                <td>{item.subjectname}</td>
                                                <td>{item.levelname}</td>
                                                <td>{item.iscode ? "True" : "False"}</td>
                                                <td>
                                                    <i
                                                    className="mdi mdi-tooltip-edit mdi-big font20 pointer"
                                                    title="Edit Record"
                                                    onClick={() => handleEdit(Number(item.pk))}
                                                    ></i>
                                                    <i
                                                    className="mdi mdi-delete mdi-big font20 pointer"
                                                    title="Delete Record"
                                                    onClick={() => handleDelete(item.pk)}
                                                    ></i>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="bottom-right" reverseOrder={false} />
        </>
    );
}

export default Question;